module.exports = __webpack_public_path__ + "img/5.ca6e9f72.png";